module.exports = __webpack_public_path__ + "img/chijieban2.2008b977.jpg";